module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<label class="emirates-checkbox checkbox">\n    <div class="emirates-checkbox__wrapper">\n        <input type="checkbox" data-layer-name="">\n        <div class="checkboxStyle"><span class="icon icon-i16_check_thin"></span></div>\n        Туры на Emirates\n    </div>\n    <div class="emirates-checkbox__img"></div>\n</label>\n';
}
return __p;
};
